<template>
    <div>
        <div class="row">
            <div class="col-md-6 offset-3">
                <div class="card form-body">
                    <div class="card-body">
                        <nav class="nav nav-pills nav-justified" v-if="false" >
                            <a class="nav-link" @click="active_tab = 'outgoing'" :class="active_tab == 'outgoing' ? 'active' : ''" aria-current="page" href="#" >
                                <i class="fa fa-comment mr-2" :class="active_tab == 'outgoing' ? 'text-white' : ''" ></i> Configure Outgoing Mail (SMTP)
                            </a>
                            <a class="nav-link" @click="active_tab = 'imap'" :class="active_tab == 'imap' ? 'active' : ''" aria-current="page" href="#" >
                                <i class="fa fa-comment mr-2" :class="active_tab == 'imap' ? 'text-white' : ''" ></i>  Configure Incoming Mail (IMAP)
                            </a>
                        </nav>
                        <legend v-if="true"><h5>Configure Outgoing Mail (SMTP)</h5></legend>
                        <hr>
                        <div>
                            <smtpEmailConfig v-if="active_tab == 'outgoing'"></smtpEmailConfig>
                            <imapConfig v-if="active_tab == 'imap' && false"></imapConfig>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import smtpEmailConfig from "./smtpEmailConfig.vue";
import imapConfig from "./imapConfig.vue";
import { mapGetters } from "vuex";

export default {
    components:{
        smtpEmailConfig,
        imapConfig
    },
  data() {
    return {
        active_tab: "outgoing",
      breadCrumbs: [
        {
          id: 1,
          title: "Dashboard",
          route: "client.dashboard"
        },
        {
          id: 2,
          title: "Setting",
          route: ""
        },
        {
          id: 3,
          title: "Configure Outgoing Mail (SMTP)",
          route: ""
        }
      ],
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  },
  methods: {
    
  }
};
</script>